export const ROAD_INFRASTRUCTURE = "ROAD_INFRASTRUCTURE";
export const MARKET_INFRASTRUCTURE = "MARKET_INFRASTRUCTURE";
export const BASIC_SCHOOLS = "BASIC_SCHOOLS";
export const ICT = "ICT";
export const HEALTH_FACILITY = "HEALTH_FACILITY";
export const OFFICE_ADMINISTRATION = "OFFICE_ADMINISTRATION";
export const OTHER_INFRUSTRUCTURE = "OTHER_INFRUSTRUCTURE";
export const ELECTRICITY = "ELECTRICITY";
export const SET_INFRASTRUCTURE = "SET_INFRASTRUCTURE"